import React from 'react'

import { Content, Header, Logo } from './styles'

import { Icon, IconSize } from '@thriveglobal/thrive-ui-lib'
import LanguageSwitcher from '@elements/LanguageSwitcher'

import iconBars from '@images/icons/icon_bars.svg'
import logo from '@images/logo-leaf.svg'

type Props = {
  links: any
  toggleSidenav: Function
}

export const SidenavAppContent: React.FC<Props> = ({
  toggleSidenav,
  links,
}) => {
  return (
    <>
      <Header>
        <Logo src={logo} />
        <Icon
          size={IconSize.xs}
          iconSrc={iconBars}
          onClick={() => toggleSidenav()}
        />
      </Header>
      <Content data-testid="sidebar-content-details">
        <LanguageSwitcher />
        {links}
      </Content>
    </>
  )
}
